<template>
  <router-view :defaultHeader="defaultHeader"></router-view>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'RentalObjectTenanciesView',
  props: {
    defaultHeader: {
      type: String,
      required: true,
    },
  },
});
</script>
